/**
 * Parses strings written with either comma or dot decimal separators to numbers.
 * @param value The string or number to parse.
 * @returns The parsed number, or NaN if the input is not a valid number.
 */
export function parseNumber(value: string | number): number {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Number.parseFloat(value.replace(",", "."));
    return parsed;
  }
  return Number.NaN;
}
